// extracted by mini-css-extract-plugin
module.exports = {"FooterCopyright":"styles_FooterCopyright__R4FIS","height":"styles_height__GPs5y"};